import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AuthorFunding from "../pages/author-funding/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/author-funding",
    element: <AuthorFunding />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
